import type { ComponentType } from 'react'
import { PageMeta } from '@/components/seo/PageMeta'
import { LandingLayout } from '@/components/layout/LandingLayout'
import type { PlatformFeature, PlatformLayout } from '@/data/platform'
import type { LayoutProps } from './layouts/shared'
import { AiGenerationLayout } from './layouts/AiGenerationLayout'
import { TemplatesLayout } from './layouts/TemplatesLayout'
import { DamLayout } from './layouts/DamLayout'
import { ExcelLayout } from './layouts/ExcelLayout'
import { ProductivityLayout } from './layouts/ProductivityLayout'
import { SecurityLayout } from './layouts/SecurityLayout'
import { IntegrationsLayout } from './layouts/IntegrationsLayout'
import { AnalyticsLayout } from './layouts/AnalyticsLayout'

interface PlatformPageProps {
  feature: PlatformFeature
}

/** One layout per platform page (`feature.layout`); see `./layouts/`. */
const LAYOUTS: Record<PlatformLayout, ComponentType<LayoutProps>> = {
  'dark-product': AiGenerationLayout,
  creative: TemplatesLayout,
  'asset-listing': DamLayout,
  'giant-word': ExcelLayout,
  statement: ProductivityLayout,
  numbers: SecurityLayout,
  'sticky-split': IntegrationsLayout,
  heatmap: AnalyticsLayout,
}

/**
 * Platform feature page. Every page shares the nav, footer, FAQ with the
 * platform index and a closing CTA band, but each has its own composition
 * from the hero down, chosen by the feature's `layout`.
 */
export function PlatformPage({ feature }: PlatformPageProps) {
  const Layout = LAYOUTS[feature.layout]
  return (
    <>
      <PageMeta title={feature.metaTitle} description={feature.metaDescription} />
      <LandingLayout>
        <div data-layout={feature.layout}>
          <Layout feature={feature} />
        </div>
      </LandingLayout>
    </>
  )
}
